export const navigationConstants = {
    CHANGE_STORY: 'NAVIGATION_CHANGE_STORY',
    CHANGE_VIEW: 'NAVIGATION_CHANGE_VIEW',
    CHANGE_PANEL: 'NAVIGATION_CHANGE_PANEL',
};
